import React from 'react';

// Hooks
import useUpdateQuickStartGuideFlag from '../useUpdateQuickStartGuideFlag';

// Uilts
import { trackQuickStartDismissClick } from 'Shared/tracking/tracking';

// Components
import { WpButton, WpButtonGroup } from 'Wpds/components/button';

// Styles
import './DismissStep.scss';

type Props = {
  navigateToList: Function;
};

const DismissStep = ({ navigateToList }: Props) => {
  const { dismissGuide } = useUpdateQuickStartGuideFlag();

  const handleClick = () => {
    navigateToList();
    trackQuickStartDismissClick();
    dismissGuide();
  };

  const baseClassName = 'DismissStep';
  return (
    <>
      <div className={baseClassName}>
        <div className={`${baseClassName}__button`}>
          <WpButtonGroup stacked>
            <WpButton variant="secondary" size="lg" onClick={handleClick}>
              Dismiss for good
            </WpButton>
          </WpButtonGroup>
        </div>
      </div>
    </>
  );
};
export default DismissStep;
